<template>
  <div class="city-trigger" @click="switchCity">
    <i v-show="!pagelocating" class="icon"></i>
    <span>{{ pagelocating ? '定位中...' : cityname }}</span>
  </div>
</template>
<script>
export default {
  props: ['pagelocating', 'cityname'],
  data() {
    return {}
  },
  methods: {
    switchCity() {
      this.trackClick(200001, '首页城市选择')
      location.href = `https://life.cekid.com/h5/city-choose?referer=${encodeURIComponent(
        location.href
      )}`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.city-trigger {
  display: flex;
  height: rem(132px);
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: rem(132px);
  position: absolute;
  left: rem(30px);
  top: rem(24px);
  z-index: 9;
  color: #666;
  transform: scale(0.33333) translate(-100%, -100%);
  display: flex;
  padding: 0 rem(54px);
  .icon {
    display: inline-block;
    flex: none;
    width: rem(60px);
    height: rem(132px);
    background: url('~@/assets/images/icon_location@3x.png') no-repeat right
      center;
    background-size: rem(60px) auto;
  }
  span {
    margin-left: 10px;
    flex: 1 1 auto;
    display: block;
    word-break: keep-all;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #fff;
    font-size: rem(78px);
    line-height: rem(132px);

    max-width: 3em;
  }
}
</style>
